export default "__VITE_ASSET__ChuVJOjg__"